import type { HraInfo } from "hooks/use-hra-info/use-hra-info.hook";

// URL pattern for the HRA toolbox activity:
//   /health-journey/campaign/<campaignId>/activity/<activityId>/toolbox
// `campaign/<campaignId>` is dropped when campaignId is missing — campaignId
// is optional, and the SDK route segments tolerate the bare activity path.
export const buildHraUrl = (hraInfo: HraInfo): string => {
  const base = "/health-journey";
  const campaignSegment = hraInfo.campaignId
    ? `/campaign/${encodeURIComponent(hraInfo.campaignId)}`
    : "";
  const activitySegment = `/activity/${encodeURIComponent(
    hraInfo.activityId
  )}/toolbox`;
  return `${base}${campaignSegment}${activitySegment}`;
};
